import { useEffect, useState } from "react";
import xhrCaller, { useXhrCaller } from "./xhr-caller";

export function useXhrFileGetExamRequestFile (id) {
	const [params, setParams] = useState(null);
	useEffect(() => {
		if(id){
			setParams({ srv: 'api', action: `File/GetExamRequestFile`, method: 'get', responseType: "blob", json: false, data: { Id : id }});
		}
	}, [id])

	var result = useXhrCaller(params);	
	return result;
};

export function useXhrFileGetExamRequestFileList (examId) {
	const [params, setParams] = useState(null);
	useEffect(() => {
		if(examId){
			setParams({ srv: 'api', action: `File/GetExamRequestFileList`, method: 'get', json: false, data: { examId : examId }});
		}
	}, [examId])

	var result = useXhrCaller(params);	
	return result;
};

export function useXhrFileGetExamRequestFileListByIds (examIds) {
	const [params, setParams] = useState(null);
	useEffect(() => {
		if(examIds){
			setParams({ srv: 'api', action: `File/GetExamRequestFileListByIds`, method: 'get', json: false, data: { examIds : examIds }});
		}
	}, [examIds])

	var result = useXhrCaller(params);	
	return result;
};


export function useXhrFileGetUserSignature (id) {
	const [params, setParams] = useState(null);
	useEffect(() => {
		if(id){
			setParams({ srv: 'api', action: `File/GetUserSignature`, method: 'get', json: false, responseType: "blob", data: { userId : id }});
		}
	}, [id])

	var result = useXhrCaller(params);	
	return result;
};

export function useXhrFileGetInstitutionReport (instId) {
	const [params, setParams] = useState(null);
	useEffect(() => {
		if(instId){
			setParams({ srv: 'api', action: `File/GetInstitutionReport`, method: 'get', data: { institutionId : instId }});
		}
	}, [instId])

	var result = useXhrCaller(params);	
	return result;
};

export function useXhrFileGetReportBodyFile (reportId) {
	const [params, setParams] = useState(null);
	useEffect(() => {
		if(reportId){
			setParams({ srv: 'api', action: `File/GetReportBodyFile`, method: 'get', data: { reportId : reportId }});
		}
	}, [reportId])

	var result = useXhrCaller(params);	
	return result;
};

export function useXhrFileGetReportSignedFile (id) {
	const [params, setParams] = useState(null);
	useEffect(() => {
		if(id){
			setParams({ srv: 'api', action: `File/GetReportSignedFile`, method: 'get', responseType: "blob", json: false, data: { reportId : id }});
		}
	}, [id])

	var res = useXhrCaller(params);	
	let result = "";
	if (res?.result) {
		const arrayBufferView = res?.result;
		const blob = new Blob([arrayBufferView], { type: "application/pdf" });
		const urlCreator = window.URL || window.webkitURL;
		const imageUrl = urlCreator.createObjectURL(blob);
		result = imageUrl;
	}
	return result;
};

export const xhrFileGetExamRequestFile = async (token, id) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `File/GetExamRequestFile?Id=${id}`, method: 'get', responseType: "blob", json: false});	
	return result;
};
export const xhrFileGetExamRequestFileList = async (token, examId) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `File/GetExamRequestFileList?examId=${examId}`, method: 'get'});
	return result;
};

export const xhrFileGetExamRequestFileListByIds = async (token, examIds) => {
	let qs = ``;
	examIds.forEach((x, i) =>
		i === examIds.length - 1
			? (qs = qs + `examIds=${x}`)
			: (qs = qs + `examIds=${x}&`)
	);

	var result = await xhrCaller({ bearer: token, srv: 'api', action: `File/GetExamRequestFileListByIds?${qs}`, method: 'get'});	
	return result;
};

export const xhrFileGetUserSignature = async (token, id) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `File/GetUserSignature?userId=${id}`, method: 'get', responseType: "blob", json: false});	
	return result;
};

export const xhrFileGetInstitutionReport = async (token, instId) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `File/GetInstitutionReport?institutionId=${instId}`, method: 'get'});	
	return result;
};

export const xhrFileGetReportBodyFile = async (token, reportId) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `File/GetReportBodyFile?reportId=${reportId}`, method: 'get'});	
	return result;
};

export const xhrFileGetReportSignedFile = async (token, id) => {
	var res = await xhrCaller({ bearer: token, srv: 'api', action: `File/GetReportSignedFileWatermark?reportId=${id}`, method: 'get', responseType: "blob", json: false});

	let result = "";
	if (res?.result) {
		const arrayBufferView = res?.result;
		const blob = new Blob([arrayBufferView], { type: "application/pdf" });
		const urlCreator = window.URL || window.webkitURL;
		const imageUrl = urlCreator.createObjectURL(blob);
		result = imageUrl;
	}
	return result;
};
